import React from 'react'
import { useQuery, useMutation } from '@apollo/client'
import CurrentUser from '../../CurrentUser'
import Loading from '../../Loading'
import Error from '../../Error'
import gatewaysQuery from '../../Gateways/List/Items/lib/query'
import GroupedItems from '../GroupedItems'
import DefaultGroupLabel from './DefaultGroupLabel'
import onReorder from './lib/onReorder'
import reorderUpdate from './lib/reorderUpdate'
import groupDroppableId from './lib/groupDroppableId'
import groupIsDropDisabled from './lib/groupIsDropDisabled'
import itemIsDragDisabled from './lib/itemIsDragDisabled'
import groups from './lib/groups'
import refetchQueries from './lib/refetchQueries'

export default ({
  items,
  reorderMutation,
  reorderMutationName,
  query,
  variables = undefined,
  queryName,
  includeGatewayNull = false,
  GroupLabel = DefaultGroupLabel,
  gatewayIdKey = 'gatewayId',
  ...rest
}) => {
  const [reorder, mutationProps] = useMutation(reorderMutation, {
    refetchQueries: refetchQueries({ query, variables }),
    update: reorderUpdate({
      reorderMutationName,
      query,
      queryName,
      gatewayIdKey,
    }),
  })

  const { loading, error, data: gatewaysData } = useQuery(gatewaysQuery)

  if (loading) return <Loading />
  if (error) return <Error />

  return (
    <CurrentUser>
      {({ currentUser }) => (
        <>
          <GroupedItems
            groupKey='gateway'
            groupLabel={GroupLabel}
            groupDroppableId={groupDroppableId}
            groupIsDropDisabled={groupIsDropDisabled({ currentUser })}
            itemIsDragDisabled={itemIsDragDisabled({
              currentUser,
              gatewayIdKey,
            })}
            groups={groups({
              items,
              gatewaysData,
              includeGatewayNull,
              gatewayIdKey,
            })}
            hideEmptyGroups
            onReorder={onReorder({
              reorder,
              reorderMutationName,
              items,
            })}
            {...rest}
          />
          {mutationProps.error && <Error />}
        </>
      )}
    </CurrentUser>
  )
}
